export const sessionMaxWidth = {
	summative: 960,
	formative: 840,
	splitLayout: 1300,
};

export const FAB_BOTTOM_POSITION = 80 + 24;

/**
 * `peek` clears the handle plus a full stacked stat tile, so the collapsed sheet
 * never cuts a stat in half.
 */
export const postAnswerSnapPoint = {
	peek: 104,
	ai: 340,
	default: 240,
};

export const postAnswerSnapIndex = {
	peek: 0,
	mid: 1,
	expanded: 2,
};

export const getStudySessionBottomBarHeight = ({
	safeAreaBottom,
	isMobile,
	isSummativeTest,
	inReviewMode,
}: {
	safeAreaBottom: number;
	isMobile: boolean;
	isSummativeTest?: boolean;
	inReviewMode?: boolean;
}) => {
	const insetBottom = Math.max(safeAreaBottom - 16, 0);
	const base = 80;
	return (
		base +
		insetBottom +
		(isMobile || (isSummativeTest && !inReviewMode) ? 0 : 16)
	);
};

/**
 * Bottom padding needed after answering, so content behind the post-answer
 * sheet remains scrollable.
 *
 * Only the sheet's height counts—the session shell positions the bottom bar
 * below content already. If layouts reserve extra space, pass `reservedBottomSpace`.
 */
export const getPostAnswerContentPadding = ({
	isAiItemType,
	reservedBottomSpace = 0,
}: {
	isAiItemType?: boolean;
	reservedBottomSpace?: number;
} = {}) =>
	Math.max(
		(isAiItemType ? postAnswerSnapPoint.ai : postAnswerSnapPoint.default) -
			reservedBottomSpace,
		0,
	);
